var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"btn titillium-sm",class:{ deactive: !_vm.payplusLink },attrs:{"disabled":!_vm.payplusLink},on:{"click":function($event){return _vm.openLink()}}},[_vm._v("\n    "+_vm._s(_vm.text.nextButton)+" "),_c('em')])])
}
var staticRenderFns = []

export { render, staticRenderFns }